import { call, put } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';
import apiRequests from 'config/services';
import { takeLatest } from 'redux-saga/effects';
import { calculationProcessStepConstants, sagaGetCalculationProcessStepListingAction } from 'saga/actions/calculationprocessStep';
import { CalculationProcessStep } from 'store/types/assembler';

export function* saveCalculationProcessStepSaga(
  action: PayloadAction<{ name: string, model: CalculationProcessStep }>
): SagaIterator {
  try {
    // Destructure from the action payload
    const { name, model } = action.payload;

    // Call your API function with both arguments
    yield call(apiRequests.saveNewCalculationProcessStep, name, model);
    yield put(sagaGetCalculationProcessStepListingAction())      // Refresh the list of calculation process steps
  } catch (e) {
  }
}

// Listener saga
export function* saveCalculationProcessStepHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(calculationProcessStepConstants.SAGA_SAVE_PROCESS_STEP, saveCalculationProcessStepSaga)
}
